import React, { useState } from "react";
import "./Navbar.css";
import { RiArrowDropDownLine } from "react-icons/ri";
import { IoIosMailOpen } from "react-icons/io";
import { FaFacebookF, FaHeadphones, FaPhoneVolume } from "react-icons/fa6";
import { GiAlarmClock } from "react-icons/gi";
import { Link } from "react-router-dom";
import { HiOutlineMenuAlt3, HiOutlinePhoneIncoming } from "react-icons/hi";
import BookingFormModal from "./BookingFormModal";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { BsInstagram, BsTwitter } from "react-icons/bs";
const Navbar = () => {
  const [active, setActive] = useState(false);
  const [serviceActive, setServiceActive] = useState(false);

  const [activeModal, setActiveModal] = useState(false);
  const [activeClass, setActiveClass] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  // const [active, setIsActive] = useState(false);

  const handleMenuClick = () => {
    setIsOpen(!isOpen);
    setActive(!active);
  };

  // const handleScroll = () => {
  //   setIsSticky(window.scrollY > 40);
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleBookAppointments = () => {
    setActiveModal(!activeModal);
  };
  const handleBookAppointment = () => {
    setActiveModal(!activeModal);
    setActive(false);
  };

  return (
    <header id="masthead" className="header ttm-header-style-03">
      <div class="top-header">
        <div class="container">
          <div class="header-left">
            <Link
              to="tel:+918882852726"
              style={{ color: "#fff", fontSize: "14px" }}
            >
              <HiOutlinePhoneIncoming
                style={{ marginRight: "10px" }}
                size={25}
              />
              <strong>Phone :</strong> +918882852726
            </Link>
          </div>
          <div class="header-right">
            <div class="ht-right-email">
              <Link
                to="mailto:info@surgerysaathi.com"
                style={{ color: "#1170b2", fontSize: "14px" }}
              >
                <MdOutlineMarkEmailRead /> info@surgerysaathi.com
              </Link>
            </div>
            <div class="ht-right-social">
              <Link
                to="https://www.facebook.com/share/186Hhz2LZt/"
                target="_blank"
              >
                <FaFacebookF class="fab fa-facebook-f" color="#000" />
              </Link>
            </div>
            <div class="ht-right-social">
              <Link
                to="https://www.instagram.com/surgerysaathi?igsh=dnQ0YTBub2RxZHd4"
                target="_blank"
              >
                <BsInstagram class="fab fa-twitter" color="#000" />
              </Link>
            </div>
            <div class="ht-right-social">
              <Link to="#">
                <BsTwitter class="fab fa-linkedin-in" color="#000" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div id="site-header-menu" className="site-header-menu">
        <div className="site-header-menu-inner ttm-bgcolor-white ttm-stickable-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                {/*site-navigation */}
                <div className="site-navigation d-flex flex-row align-items-center justify-content-between">
                  {/* site-branding */}
                  <div className="site-branding">
                    <Link className="home-link" rel="home" to="/">
                      <img
                        id="logo-img"
                        width={167}
                        height={53}
                        style={{ height: "80px" }}
                        className="img-fluid img-img-surgerysaathi"
                        src="/Images/surgery-logg.png"
                        alt="logo-img"
                      />
                    </Link>
                  </div>
                  {/* site-branding end */}
                  <div className="d-flex flex-row">
                    <div className="btn-show-menu-mobile menubar ">
                      <div className="menubar--squeeze">
                        <div
                          className="navbar-booking-appointment"
                          onClick={handleBookAppointments}
                        >
                          Book An Appointment
                        </div>
                        <HiOutlineMenuAlt3
                          className="menubar-inner"
                          size={30}
                          onClick={() => setActive(!active)}
                          color="#1170b4"
                        />
                      </div>
                    </div>
                    {/* menu */}
                    <nav
                      className="main-menu menu-mobile large-screen-navs"
                      id="menu"
                    >
                      <ul className="menu">
                        <li
                          className={`mega-menu-item ${
                            activeClass === 0 ? "active" : ""
                          }`}
                          onClick={() => setActiveClass(0)}
                        >
                          <Link to="/" className="mega-menu-link">
                            Home
                            <RiArrowDropDownLine size={24} />
                          </Link>
                        </li>
                        <li
                          className={`mega-menu-item ${
                            activeClass === 1 ? "active" : ""
                          }`}
                          onClick={() => setActiveClass(1)}
                        >
                          <Link className="mega-menu-link">
                            Service
                            <RiArrowDropDownLine size={24} />{" "}
                          </Link>
                          <ul className="mega-submenu">
                            <li>
                              <Link to="/rhinoplasty">Rhinoplasty</Link>
                            </li>
                            <li>
                              <Link to="/gynaecomastia">Gynaecomastia</Link>
                            </li>
                            <li>
                              <Link to="/lipoma-removal">lipoma removal</Link>
                            </li>
                            {/* Ophthalmology  */}
                            <li>
                              <Link to="/ophthalmology">Ophthalmology</Link>
                            </li>
                            {/* <li>
                              <Link to="/orthopedic">Orthopedic</Link>
                            </li> */}
                          </ul>
                        </li>
                        <li
                          className={`mega-menu-item ${
                            activeClass === 2 ? "active" : ""
                          }`}
                          onClick={() => setActiveClass(2)}
                        >
                          <Link to="/about-us" className="mega-menu-link">
                            About Us <RiArrowDropDownLine size={24} />
                          </Link>
                        </li>

                        <li
                          className={`mega-menu-item ${
                            activeClass === 3 ? "active" : ""
                          }`}
                          onClick={() => setActiveClass(3)}
                        >
                          <Link to="/contact-us">Contact Us</Link>
                        </li>
                        <li
                          className="mega-menu-item"
                          onClick={() => setActiveModal(!activeModal)}
                        >
                          <Link className="">Book An Appointment</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {active === true && (
        <div className="phone-menuu-section">
          <ul className="ul-phone-menuu" style={{ paddingLeft: "0px" }}>
            <li onClick={() => setActive(false)}>
              <Link to="/">Home</Link>
            </li>
            <li onClick={() => setServiceActive(!serviceActive)}>
              <Link>Service</Link>
              {serviceActive === true && (
                <ul className="ul-phone-menuu" style={{ paddingLeft: "0px" }}>
                  <li onClick={() => setActive(false)}>
                    {" "}
                    <Link to="/rhinoplasty">Rhinoplasty </Link>
                  </li>
                  <li onClick={() => setActive(false)}>
                    {" "}
                    <Link to="/gynaecomastia">Gynecomastia</Link>
                  </li>
                  <li onClick={() => setActive(false)}>
                    <Link to="lipoma-removal">Lipoma removal</Link>
                  </li>
                  {/* Ophthalmology */}
                  <li onClick={() => setActive(false)}>
                    <Link to="/ophthalmology">Ophthalmology</Link>
                  </li>
                  {/* <li onClick={() => setActive(false)}>
                    <Link to="/orthopedic">Orthopedic</Link>
                  </li> */}
                </ul>
              )}
            </li>

            <li onClick={() => setActive(false)}>
              {" "}
              <Link to="/about-us">About Us</Link>
            </li>

            <li onClick={() => setActive(false)}>
              {" "}
              <Link to="/contact-us">Contact Us</Link>
            </li>
          </ul>
          <div
            className="navbar-book-an-appointment"
            onClick={handleBookAppointment}
          >
            Book An Appointment
          </div>
        </div>
      )}
      {activeModal ? (
        <BookingFormModal active={activeModal} setActive={setActiveModal} />
      ) : (
        ""
      )}
      {/* site-header-menu end*/}
    </header>
  );
};

export default Navbar;
